mutation TravelAuthorizationDelete($input: TravelAuthorizationDeleteInput!) {
  travelAuthorizationDelete(input: $input) {
    deletedEntities {
      id
      rowTimestamp
    }
  }
}
